import { render, staticRenderFns } from "./PlacardPop.vue?vue&type=template&id=28a5c634&scoped=true&"
import script from "./PlacardPop.vue?vue&type=script&lang=js&"
export * from "./PlacardPop.vue?vue&type=script&lang=js&"
import style0 from "./PlacardPop.vue?vue&type=style&index=0&id=28a5c634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5c634",
  null
  
)

export default component.exports